const EMPTY_BET = {
	fixtureIdentifier: null,
	groupIdentifier: null,
	winnerBet: null,
	homeTeamScore: "",
	awayTeamScore: "",
};

const EMPTY_LEAGUE_BET = {
	playerIdentifier: "",
	leagueIdentifier: "",
	groupIdentifier: "",
	success: null,
	betTypeId: null,
	playerBet: "",
	earnedPoints: null,
};

export const normalizePlayerBetsForView = (fixtureBets = [], dateMatchs = []) =>
	fixtureBets.map((item, index) => ({
		...item,
		fixture: {
			...item.fixture,
			rawDate: item.fixture.date,
			date: dateMatchs[index] ?? item.fixture.date,
		},
		bet: item.bet
			? {
					...item.bet,
			  }
			: {
					...EMPTY_BET,
			  },
	}));

export const normalizeLeagueBetsResponse = (leagueBets = []) =>
	leagueBets.map((item) => ({
		...item,
		bet: item.bet
			? {
					...item.bet,
			  }
			: {
					...EMPTY_LEAGUE_BET,
			  },
	}));

export const groupLeagueBetsByLeague = (leagueBets = [], currentGroupIdentifier) =>
	leagueBets.reduce((accumulator, current) => {
		if (current.group.uniqueIdentifier !== currentGroupIdentifier) {
			return accumulator;
		}

		const leagueId = current.league.uniqueIdentifier;

		if (!accumulator[leagueId]) {
			accumulator[leagueId] = {
				league: current.league,
				items: [],
			};
		}

		accumulator[leagueId].items.push(current);
		return accumulator;
	}, {});
